import { render, staticRenderFns } from "./addSconday.vue?vue&type=template&id=321294ec&scoped=true&"
import script from "./addSconday.vue?vue&type=script&lang=js&"
export * from "./addSconday.vue?vue&type=script&lang=js&"
import style0 from "./addSconday.vue?vue&type=style&index=0&id=321294ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321294ec",
  null
  
)

export default component.exports